import React from "react";
import styled from "@emotion/styled";
import EditTags from "../LeadActions/Components/EditTags/EditTags.js";
import Timeline from "../../Timeline/Timeline";
import ReplyIcon from '@mui/icons-material/Reply';
import CancelIcon from '@mui/icons-material/Cancel';
import NotesModal from "../LeadActions/Components/Notes.js";
import ReportsModal from "../LeadActions/Components/ReportsModal.js";
import AddAssignees from "../LeadActions/Components/AddAssignees/AddAssignees.js";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ConfirmUpdate from "../LeadActions/Components/LeadStatus/ConfirmUpdate.js";
import CompareRecords from "../LeadActions/Components/CompareRecords.js";
import { useNavigate } from "react-router-dom";
import InvestigateLead from "../LeadActions/Components/LeadStatus/InvestigateLead.js";
import PropertyDetails from "../LeadActions/Components/PropertyDetails.js";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ProvideFinancials from "../LeadActions/Components/ProvideFinancials.js";
import MortgageActionsNav from "./MortgageActionsNav";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { selectTeamMembersByName } from "../../../slices/teamMembersSlice.js";
import { selectViewingFromSearchBool, setViewingFromSearchBool } from "../../../slices/viewingSearchResultsSlice.js";
import { useDispatch, useSelector } from "react-redux";
import { selectViewingLead, setViewingLead } from "../../../slices/viewingLeadSlice.js";
import { selectViewingReports, setViewingReports } from "../../../slices/teamReportsSlice.js";
import { selectViewingMortgage, setViewingMortgage } from "../../../slices/viewingMortgageSlice";
import { ModalContainer } from "../../../StyledComponents";
import { selectTeamAwaitingActionLeads, selectTeamAwaitingUpdateLeads, selectTeamClosingLeads, selectTeamInvestigatingLeads, setFwdBckFilteredViewingLeads, setFwdBckViewingLeads } from "../../../slices/teamActiveLeadsSlice.js";
import { removeNotificationFromMortgage, selectBackwardViewingMortgage, selectForwardViewingMortgage, selectMortgagesFilteredBoolean, setFwdBckViewingFilteredMortgages, setFwdBckViewingMortgages } from "../../../slices/teamMortgagesSlice.js";
import { selectLeadsFilteredBoolean, selectMortgageActionsNavSelection, setLeadActionNavMenuSelection, setLeadStatusFilter, setNavSelection, setShowMortgageActionsModal, setViewingLeadActions, setViewingMortgageActions } from "../../../slices/sessionDataSlice.js";

const MortgageActionsModal = ({ handleCloseModal, userId, teamId, userFullName, dashPerspective }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()  

  const leadData = useSelector(selectViewingLead)
  const mortgageData = useSelector(selectViewingMortgage)
  const navSelection = useSelector(selectMortgageActionsNavSelection)
  const viewingReports = useSelector(selectViewingReports)
  const teamMembersByName = useSelector(selectTeamMembersByName)
  const viewingFromSearchBool = useSelector(selectViewingFromSearchBool)
  const leadsFilteredBoolean = useSelector(selectLeadsFilteredBoolean)
  const forwardViewingMortage = useSelector(selectForwardViewingMortgage)
  const backwardViewingMortgage = useSelector(selectBackwardViewingMortgage)
  const mortgagesFilteredBoolean = useSelector(selectMortgagesFilteredBoolean)

  const closingLeads = useSelector(selectTeamClosingLeads)
  const investigatingLeads = useSelector(selectTeamInvestigatingLeads)
  const awaitingActionLeads = useSelector(selectTeamAwaitingActionLeads)
  const awaitingUpdateLeads = useSelector(selectTeamAwaitingUpdateLeads)

  const handleGoToLeadActions = (mortgageStatus) => {
    dispatch( setViewingLead(leadData) )
    if (leadsFilteredBoolean || dashPerspective !== 'team') {
      dispatch( setFwdBckFilteredViewingLeads(leadData._id) )
    } else {
      dispatch( setFwdBckViewingLeads(leadData._id) )
    }
    dispatch( setNavSelection('investigations') )
    if (mortgageStatus === 'awaitingAction') {
      dispatch( setLeadStatusFilter('Awaiting Action') )
    } else if (mortgageStatus === 'investigating') {
      dispatch( setLeadStatusFilter('Investigating') )
    } else if (mortgageStatus === 'closing') {
      dispatch( setLeadStatusFilter('Closing') )
    } else {
      dispatch( setLeadStatusFilter('Awaiting PR Updates') )
    }
    dispatch( setViewingLeadActions(true) )
    dispatch( setViewingMortgageActions(false) )
    dispatch( setShowMortgageActionsModal(false) )
    navigate(`/dashboard/investigations/${mortgageData._id}`)
    dispatch( setLeadActionNavMenuSelection('compareRecords') )
  }

  const handleFwdBckViewingMortgage = (direction) => {
    if (direction === 'fwd') {
      dispatch( setViewingReports(forwardViewingMortage.reports) )
      if (forwardViewingMortage.activeLead) {
        let thisLead = {}
        thisLead = awaitingActionLeads.find(lead => lead._id === forwardViewingMortage.activeLead.toString())
        if (!thisLead) {
          thisLead = investigatingLeads.find(lead => lead._id === forwardViewingMortage.activeLead.toString())
          if (!thisLead) {
            thisLead = closingLeads.find(lead => lead._id === forwardViewingMortage.activeLead.toString())
            if (!thisLead) {
              thisLead = awaitingUpdateLeads.find(lead => lead._id === forwardViewingMortage.activeLead.toString())
            }
          }
        }
        dispatch( setViewingLead(thisLead) )
      } else {
        dispatch( setViewingLead(null) )
        dispatch( setFwdBckViewingLeads(null) )
        dispatch( setFwdBckFilteredViewingLeads(null) )
      }
      if (forwardViewingMortage.notifCount && forwardViewingMortage.notifCount > 0) {
        dispatch( removeNotificationFromMortgage({mortgageId: forwardViewingMortage._id}) )
      }
      if (mortgagesFilteredBoolean) {
        dispatch( setFwdBckViewingFilteredMortgages(forwardViewingMortage._id) )
      } else {
        dispatch( setFwdBckViewingMortgages(forwardViewingMortage._id) )
      }
      dispatch( setViewingMortgage(forwardViewingMortage) )
      navigate(`/dashboard/mortgageRepository/${forwardViewingMortage._id}`)
    } else {
      dispatch( setViewingReports(backwardViewingMortgage.reports) )
      if (backwardViewingMortgage.activeLead) {
        let thisLead = {}
        thisLead = awaitingActionLeads.find(lead => lead._id === backwardViewingMortgage.activeLead.toString())
        if (!thisLead) {
          thisLead = investigatingLeads.find(lead => lead._id === backwardViewingMortgage.activeLead.toString())
          if (!thisLead) {
            thisLead = closingLeads.find(lead => lead._id === backwardViewingMortgage.activeLead.toString())
            if (!thisLead) {
              thisLead = awaitingUpdateLeads.find(lead => lead._id === backwardViewingMortgage.activeLead.toString())
            }
          }
        }
        dispatch( setViewingLead(thisLead) )
      } else {
        dispatch( setViewingLead(null) )
        dispatch( setFwdBckViewingLeads(null) )
        dispatch( setFwdBckFilteredViewingLeads(null) )
      }
      if (backwardViewingMortgage.notifCount && backwardViewingMortgage.notifCount > 0) {
        dispatch( removeNotificationFromMortgage({mortgageId: backwardViewingMortgage._id}) )
      }
      if (mortgagesFilteredBoolean) {
        dispatch( setFwdBckViewingFilteredMortgages(backwardViewingMortgage._id) )
      } else {
        dispatch( setFwdBckViewingMortgages(backwardViewingMortgage._id) )
      }
      dispatch( setViewingMortgage(backwardViewingMortgage) )
      navigate(`/dashboard/mortgageRepository/${backwardViewingMortgage._id}`)
    }
  }

  const handleBackToSearch = () => {
    dispatch( setViewingLead(null) )
    dispatch( setViewingMortgage(null) )
    dispatch( setViewingFromSearchBool(false) )
    dispatch( setFwdBckViewingLeads(null) )
    dispatch( setFwdBckViewingMortgages(null) )
    dispatch( setViewingMortgageActions(false) )
    dispatch( setShowMortgageActionsModal(false) )
    dispatch( setFwdBckFilteredViewingLeads(null) )
    dispatch( setFwdBckViewingFilteredMortgages(null) )
    dispatch( setNavSelection('propertySearch') )
    navigate(`/dashboard/propertySearch`)
  }

  const getMortgageAddress = () => {
    return mortgageData.recordDetails.address.StreetAddressOneLine.currentValue ?
      mortgageData.recordDetails.address.StreetAddressOneLine.currentValue
    :
      mortgageData.streetAddress
  }

  const getMortgageStatusLabel = () => {
    if (mortgageData.status === 'awaitingAction') {
      return 'Potential Violation Awaiting Action'
    }
    if (mortgageData.status === 'investigating') {
      return 'Under Investigation'
    }
    if (mortgageData.status === 'closing') {
      return 'Closing Investigation'
    }
    if (mortgageData.status === 'awaitingUpdate') {
      return 'Awaiting Public Record Updates'
    }
    return 'Inactive Mortgage'
  }

  const activeActionLabel = () => {
    if (mortgageData.status === 'awaitingAction') {
      return 'View Potential Violation'
    }
    if (mortgageData.status === 'awaitingUpdate') {
      return 'View Awaiting Update'
    }
    return 'View Investigation'
  }

  return (
    <MortgageModalShell className="threePanel">
      <ModalHeader>
        <RecordControls aria-label="Mortgage navigation">
          <RecordStepButton
            type="button"
            disabled={!backwardViewingMortgage}
            onClick={backwardViewingMortgage ? () => handleFwdBckViewingMortgage('bck') : undefined}
          >
            <ArrowBackIosIcon />
            prev
          </RecordStepButton>
          <RecordStepButton
            type="button"
            disabled={!forwardViewingMortage}
            onClick={forwardViewingMortage ? () => handleFwdBckViewingMortgage('fwd') : undefined}
          >
            next
            <ArrowForwardIosIcon />
          </RecordStepButton>
        </RecordControls>
        <MortgageIdentity>
          <HeaderEyebrow>Mortgage Repository</HeaderEyebrow>
          <AddressTitle>{getMortgageAddress()}</AddressTitle>
          <StatusChip $status={mortgageData.status}>{getMortgageStatusLabel()}</StatusChip>
        </MortgageIdentity>
        <HeaderActions>
          {(mortgageData.status === 'awaitingAction' || mortgageData.status === 'investigating' || mortgageData.status === 'closing' || mortgageData.status === 'awaitingUpdate') &&
            <RepositoryButton type="button" onClick={() => handleGoToLeadActions(mortgageData.status)}>
              {activeActionLabel()}
              <OpenInNewIcon />
            </RepositoryButton>
          }
          {viewingFromSearchBool &&
            <SecondaryButton type="button" onClick={() => handleBackToSearch()}>
              <ReplyIcon />
              Back to Search
            </SecondaryButton>
          }
          <CloseButton type="button" aria-label="Close Mortgage Actions Modal" onClick={() => handleCloseModal()}>
            <CancelIcon />
          </CloseButton>
        </HeaderActions>
      </ModalHeader>
      <MortgageActionsNav mortgageData={mortgageData} reportsNumber={mortgageData.reports.length} handleCloseModal={handleCloseModal} leadData={leadData} activeLead={mortgageData.activeLead} viewingFromSearchBool={viewingFromSearchBool} handleBackToSearch={handleBackToSearch} />
      <ContentPanel>
      {navSelection === 'reports' ?
        <ReportsModal reports={viewingReports} />
      : navSelection === 'notes' ?
        <NotesModal userId={userId} userFullName={userFullName} leadData={leadData} mortgageData={mortgageData} />
      : navSelection === 'compareRecords' ?
        <CompareRecords mortgageData={mortgageData} userFullName={userFullName} leadData={leadData} teamId={teamId} location={'repository'} />
      : navSelection === 'propertyDetails' ?
        <PropertyDetails handleCloseModal={handleCloseModal} mortgageData={mortgageData} />
      : navSelection === 'investigateLead' ?
        <InvestigateLead handleCloseModal={handleCloseModal} userId={userId} teamId={teamId} userFullName={userFullName} teamMembersByName={teamMembersByName} mortgageId={mortgageData._id} leadData={{assigneeIds: []}} dashPerspective={dashPerspective} requestOrigin={'repository'} />
      : navSelection === 'editTags' ?
        <EditTags leadData={leadData} userFullName={userFullName} teamId={teamId} dashPerspective={dashPerspective} userId={userId} activeLead={mortgageData.activeLead} mortgageData={mortgageData} />
      : navSelection === 'addAssignees' ?
        <AddAssignees teamMembersByName={teamMembersByName} handleCloseModal={handleCloseModal} activeLead={mortgageData.activeLead} leadData={leadData} mortgageData={mortgageData} userFullName={userFullName} userId={userId} />
      : navSelection === 'provideFinancialsModal' || navSelection === 'provideFinancialsCard' || navSelection === 'provideTerms' ?
        <ProvideFinancials mortgageData={mortgageData} userFullName={userFullName} leadData={leadData} userId={userId} navSelection={navSelection} handleCloseModal={handleCloseModal} teamId={teamId} />
      : navSelection === 'confirmUpdate' ?
        <ConfirmUpdate handleCloseModal={handleCloseModal} leadData={leadData} userId={userId} userFullName={userFullName} teamId={teamId} mortgageData={mortgageData} />
      :
        <></>
      }
      </ContentPanel>
      <TimelinePanel>
        <TimelineHeader>Timeline</TimelineHeader>
        <TimelineBody>
          <Timeline timeline={mortgageData.timeline} origin={'modal'} />
        </TimelineBody>
      </TimelinePanel>
    </MortgageModalShell>
  )
}

const MortgageModalShell = styled(ModalContainer)(({ theme }) => `
  &.threePanel {
    display: grid;
    grid-template-columns: 22rem minmax(0, 1fr) 34rem;
    grid-template-rows: auto minmax(0, 1fr);
    gap: 1rem;
    height: min(66rem, calc(100vh - 4rem));
    max-height: calc(100vh - 4rem);
    padding: 1rem;
    background: ${theme.palette.common.pageBackground};
    overflow: hidden;
  }
`)

const ModalHeader = styled.header(({ theme }) => `
  grid-column: 1 / 4;
  grid-row: 1;
  min-height: 6.4rem;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1rem;
  background: ${theme.palette.common.cardBackground};
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  box-shadow: 0 0.4rem 1.4rem rgba(15, 23, 42, 0.08);
`)

const RecordControls = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const RecordStepButton = styled.button(({ theme }) => `
  min-width: 5.6rem;
  height: 3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  padding: 0 0.7rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.6rem;
  background: ${theme.palette.common.white};
  color: ${theme.palette.primary.main};
  font-size: 0.9rem;
  font-weight: 800;
  text-transform: uppercase;
  cursor: pointer;

  svg {
    width: 1rem;
    height: 1rem;
  }

  &:disabled {
    color: ${theme.palette.common.grayText};
    background: ${theme.palette.common.grayBorderLight};
    cursor: not-allowed;
    opacity: 0.62;
  }

  &:not(:disabled):hover {
    border-color: ${theme.palette.primary.main};
    background: ${theme.palette.common.grayBorderLight};
  }
`)

const MortgageIdentity = styled.div`
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  column-gap: 0.8rem;
  row-gap: 0.25rem;
  align-items: center;
`

const HeaderEyebrow = styled.div(({ theme }) => `
  grid-column: 1 / 3;
  color: ${theme.palette.common.grayText};
  font-size: 0.76rem;
  font-weight: 900;
  letter-spacing: 0.1rem;
  line-height: 1.2;
  text-transform: uppercase;
`)

const AddressTitle = styled.h2(({ theme }) => `
  min-width: 0;
  margin: 0;
  color: ${theme.palette.common.black};
  font-size: 1.42rem;
  font-weight: 900;
  line-height: 1.18;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`)

const StatusChip = styled.div(({ theme, $status }) => {
  const statusStyles = {
    awaitingAction: {
      color: '#9a3412',
      border: 'rgba(154,52,18,0.24)',
      background: 'rgba(194,65,12,0.09)',
    },
    investigating: {
      color: '#1e40af',
      border: 'rgba(37,99,235,0.24)',
      background: 'rgba(37,99,235,0.08)',
    },
    closing: {
      color: '#5b21b6',
      border: 'rgba(124,58,237,0.24)',
      background: 'rgba(124,58,237,0.08)',
    },
    awaitingUpdate: {
      color: '#115e59',
      border: 'rgba(15,118,110,0.24)',
      background: 'rgba(15,118,110,0.08)',
    },
    inactive: {
      color: theme.palette.common.grayText,
      border: theme.palette.common.grayBorder,
      background: theme.palette.common.grayBorderLight,
    },
  }
  const style = statusStyles[$status] || statusStyles.inactive

  return `
    justify-self: start;
    display: inline-flex;
    align-items: center;
    min-height: 2rem;
    padding: 0.35rem 0.7rem;
    border: 0.1rem solid ${style.border};
    border-radius: 999rem;
    background: ${style.background};
    color: ${style.color};
    font-size: 0.78rem;
    font-weight: 900;
    line-height: 1.1;
    white-space: nowrap;
  `
})

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  min-width: 0;
`

const HeaderButtonBase = styled.button(({ theme }) => `
  height: 3.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.6rem;
  background: ${theme.palette.common.white};
  color: ${theme.palette.primary.main};
  font-size: 0.95rem;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:hover {
    border-color: rgba(22, 163, 74, 0.35);
    background: ${theme.palette.common.grayBorderLight};
  }
`)

const RepositoryButton = styled(HeaderButtonBase)``

const SecondaryButton = styled(HeaderButtonBase)(({ theme }) => `
  color: ${theme.palette.common.grayText};
`)

const CloseButton = styled.button(({ theme }) => `
  width: 3.2rem;
  height: 3.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 50%;
  background: ${theme.palette.common.white};
  color: ${theme.palette.common.grayText};
  cursor: pointer;

  svg {
    width: 1.7rem;
    height: 1.7rem;
  }

  &:hover {
    color: ${theme.palette.common.black};
    background: ${theme.palette.common.grayBorderLight};
  }
`)

const ContentPanel = styled.main(({ theme }) => `
  grid-column: 2;
  grid-row: 2;
  height: 100%;
  min-width: 0;
  min-height: 0;
  max-height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  overflow: hidden;
  background: ${theme.palette.common.cardBackground};
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;

  > * {
    height: 100%;
    width: 100%;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
  }
`)

const TimelinePanel = styled.aside(({ theme }) => `
  grid-column: 3;
  grid-row: 2;
  height: 100%;
  min-width: 0;
  min-height: 0;
  max-height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  background: ${theme.palette.common.cardBackground};
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  overflow: hidden;
`)

const TimelineHeader = styled.div(({ theme }) => `
  flex: 0 0 auto;
  padding: 1rem 1.2rem;
  color: ${theme.palette.common.black};
  font-size: 1.1rem;
  font-weight: 750;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.grayBorderLight};
`)

const TimelineBody = styled.div(({ theme }) => `
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  overflow: hidden;
  background: ${theme.palette.common.grayBorder};

  > * {
    min-height: 0;
    height: 100%;
    max-height: 100%;
  }
`)

export default MortgageActionsModal;
